export default __webpack_public_path__ + "images/430ae69a542d48f29d72a4a659e16555.svg";